"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteVideoQualityStatsManager = void 0;
const array_helpers_1 = require("../util/array_helpers");
const remote_video_quality_utils_1 = require("../util/remote_video_quality_utils");
//     3. provides averages of the VQS stats over the last N periods
class RemoteVideoQualityStatsManager {
    constructor(numObservationsToConsider, _logger) {
        this.numObservationsToConsider = numObservationsToConsider;
        this._logger = _logger;
        this.stats = [];
        this.logger = _logger.extend('sdk-chime-video:remote_video_quality_stats_manager');
    }
    addObservation(webRTCStats, remoteVideoEnabled) {
        const vqsStats = remoteVideoEnabled
            ? (0, remote_video_quality_utils_1.convertRTCStatsToVQSStats)(webRTCStats, this.logger)
            : null;
        (0, array_helpers_1.addToArrayKeepingMostRecentItems)(this.stats, vqsStats, this.numObservationsToConsider);
    }
    findAverages() {
        const observationsToConsider = this.stats.filter(stat => stat != null); // The nulls will be filtered out
        const observationLength = observationsToConsider.length;
        if (observationLength === 0) {
            return null;
        }
        const totals = observationsToConsider.reduce((acc, nextVal) => {
            acc.frameRate += nextVal.frameRate;
            acc.codec = nextVal.codec; // should not change during call
            acc.roundTripTime += nextVal.roundTripTime;
            acc.bitRate += nextVal.bitRate;
            acc.height += nextVal.height;
            acc.width += nextVal.width;
            acc.jitterBufferDelay += nextVal.jitterBufferDelay;
            return acc;
        }, {
            frameRate: 0,
            codec: null,
            roundTripTime: 0,
            bitRate: 0,
            height: 0,
            width: 0,
            jitterBufferDelay: 0,
        });
        const averages = {
            frameRate: totals.frameRate / observationLength,
            codec: totals.codec,
            roundTripTime: totals.roundTripTime / observationLength,
            bitRate: totals.bitRate / observationLength,
            height: totals.height / observationLength,
            width: totals.width / observationLength,
            jitterBufferDelay: totals.jitterBufferDelay / observationLength,
        };
        return averages;
    }
}
exports.RemoteVideoQualityStatsManager = RemoteVideoQualityStatsManager;
//# sourceMappingURL=remote_video_quality_stats_manager.js.map